var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCardNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "194px",
    height: "170px",
    viewBox: "0 0 194 170",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 43,
    y: 91,
    width: 110,
    height: 65,
    rx: 6
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-15.5%",
    y: "-20.0%",
    width: "130.9%",
    height: "152.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Extra-Large---Link-CC",
    transform: "translate(-811.000000, -357.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(750.000000, 242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(61.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Statement-Lockup"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Credit-card",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    linespacing: 18,
    fill: "#42484D"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20,
    y: 29
  }, "Credit Card Number:")), /*#__PURE__*/React.createElement("text", {
    id: "XXXX-XXXX-XXXX-XXXX",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 14,
    fontWeight: "normal",
    linespacing: 18,
    fill: "#006AFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20,
    y: 47
  }, "XXXX XXXX XXXX XXXX")), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#006AFF",
    strokeWidth: 4,
    fillRule: "nonzero",
    cx: 97,
    cy: 33.5,
    rx: 95,
    ry: 31.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#42484D",
    fillRule: "nonzero",
    opacity: 0.500511533,
    x: 54,
    y: 101,
    width: 24.4285714,
    height: 10.2289562
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#42484D",
    fillRule: "nonzero",
    opacity: 0.500511533,
    x: 54,
    y: 139,
    width: 31,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#006AFF",
    fillRule: "nonzero",
    opacity: 0.504975818,
    x: 54,
    y: 122,
    width: 18.7142857,
    height: 6.22895623
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#006AFF",
    fillRule: "nonzero",
    opacity: 0.504975818,
    x: 76,
    y: 122,
    width: 18.7142857,
    height: 6.22895623
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#006AFF",
    fillRule: "nonzero",
    opacity: 0.504975818,
    x: 98,
    y: 122,
    width: 18.7142857,
    height: 6.22895623
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#006AFF",
    fillRule: "nonzero",
    opacity: 0.504975818,
    x: 120,
    y: 122,
    width: 18.7142857,
    height: 6.22895623
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#006AFF",
    strokeWidth: 4,
    fillRule: "nonzero",
    cx: 99,
    cy: 124.5,
    rx: 53,
    ry: 14.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.647892,60.5328759 L129.747374,113.098282 L118.838156,113.098282 C113.651226,110.599495 106.999838,109.098282 99.747374,109.098282 C92.4949105,109.098282 85.8435221,110.599495 80.6565921,113.098282 L69.747374,113.098282 L51.520598,60.5022615 C64.0287323,63.9533292 80.1865935,65.5 97.247374,65.5 C114.257623,65.5 130.267286,63.9624776 142.647892,60.5328759 Z",
    id: "Combined-Shape",
    fill: "#006AFF",
    fillRule: "nonzero",
    opacity: 0.3
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardNumber);
export default __webpack_public_path__ + "static/media/credit-card-number.c038f66a.svg";
export { ForwardRef as ReactComponent };